import React from "react";
import { Newsletters } from "../data/newsletters.js";

class NewsletterForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            affl: "bad",
            email: "",
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleAfflChange = this.handleAfflChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleAfflChange(e) {
        const affl = e.target.value;
        if (
            affl === "student" ||
            affl === "graduate_student" ||
            affl === "prospective_student" ||
            affl === "parent" ||
            affl === "prospective_parent" ||
            affl === "alum" ||
            affl === "faculty/staff" ||
            affl === "other"
        ) {
            this.setState({ affl: affl });
        } else {
            this.setState({ affl: "bad" });
        }
    }

    handleEmailChange(e) {
        const email = e.target.value;
        this.setState({ email: email });
    }

    handleSubmit(e) {
        e.preventDefault();

        if (this.state.affl === "bad") {
            alert("Please select a Princeton University affiliation from the dropdown.");
            return;
        }

        const dailyNewsId = "314837ec05";
        const objAffl = {
            user_email: this.state.email,
            affiliation: this.state.affl,
            newsletter_ids: [dailyNewsId],
        };

        var fetchDataAffl = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(objAffl),
        };

        fetch("https://dailyprince-subscribe-api.herokuapp.com/subscribe/affiliation", fetchDataAffl)
            .then((res) => res.json())
            .then((data) => {
                console.log(data.success);
                if (data.success === "unsuccessful") {
                    this.setState({
                        callback:
                            "Something went wrong. You might have already subscribed to this newsletter. If not, try manually subscribing to the newsletter using the link below, or contact tech@dailyprincetonian.com.",
                    });
                    this.setState({ callbackStatus: "red" });
                } else {
                    this.setState({
                        callback: "Success! Thank you for subscribing.",
                    });
                    this.setState({ callbackStatus: "green" });
                }
            });
    }

    render() {
        const { callback, callbackStatus } = this.state;
        return (
            <div className="subscription-form" id="newsletter" style={{ flex: "1" }}>
                <img
                    src="https://assets.dailyprincetonian.com/common/banner-transparent.png"
                    alt="banner"
                    className="logo-image"></img>
                <h1 style={{ textAlign: "center", fontSize: "32px", fontWeight: "700", textTransform: "uppercase", marginBottom: "15px", marginTop: "10px" }}>
                    EMAIL NEWSLETTER SUBSCRIPTION
                </h1>
                <h1 className="firstbox-text" style={{ textAlign: "center", lineHeight: "24px", marginTop: "18px" }}>
                    Subscribe to our free daily newsletter, which is delivered straight to your inbox.
                </h1>
                <hr />
                <form onSubmit={this.handleSubmit}>
                    <p className="text1">Your Email Address</p>
                    <input
                        className="subscribe"
                        id="email-input"
                        type="email"
                        name="email"
                        placeholder=""
                        onChange={this.handleEmailChange}
                        required
                    />
                    <p className="text1">Princeton University Affiliation</p>
                    <select
                        className="affl"
                        id="affl"
                        name="affl"
                        onChange={this.handleAfflChange}
                        style={{ color: this.state.affl === "bad" ? "#757575" : "inherit" }}>
                        <option value="" disabled selected></option>
                        <option value="student">Undergraduate Student</option>
                        <option value="graduate_student">Graduate Student</option>
                        <option value="prospective_student">Prospective Student</option>
                        <option value="parent">Parent</option>
                        <option value="prospective_parent">Prospective Parent</option>
                        <option value="alum">Alum</option>
                        <option value="faculty/staff">Faculty/Staff</option>
                        <option value="other">Other</option>
                    </select>
                    <br></br>
                    <div id="button" className="submit-button">
                        <input style={{ fontSize: "30px" }} className="subscribe" type="submit" value="SUBSCRIBE" />
                    </div>
                    <br />
                    <br />
                    {callback && (
                        <div id="callback-status" className={callbackStatus}>
                            {callback}
                        </div>
                    )}
                    <div className="tiny-links">
                        <p>
                            <i>
                                If you encounter problems, manually subscribe to our newsletters using the following{" "}
                                <a href={Newsletters[0].url} target="_blank" className="tiny-link">
                                    link
                                </a>.
                            </i>
                        </p>
                    </div>
                </form>
            </div>
        );
    }
}

export default NewsletterForm;
